import { useState, useEffect } from 'react';

export const getTextWidth = (text, font) => {
  // re-use canvas object for better performance
  const canvas =
    getTextWidth.canvas ||
    (getTextWidth.canvas = document.createElement('canvas'));
  const context = canvas.getContext('2d');
  context.font = font;
  const metrics = context.measureText(text);
  return Math.ceil(metrics.width);
}

export const useContainerDimensions = (ref) => {
  const getDimensions = () => !ref.current
      ? { width: null, height: null }
      : {
        width: ref.current.offsetWidth,
        height: ref.current.offsetHeight,
      };

  const [dimensions, setDimensions] = useState(getDimensions());

  // update on ref change
  useEffect(() => {
    setDimensions(getDimensions());
  }, [ref]);

  // update on resize
  useEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return dimensions;
}

export const useOnClickOutside = (ref, initialState = false) => {
  const [isOpen, setOpen] = useState(initialState);

  useEffect(() => {
    // Only bind event handlers once open is true as a minor optimization
    if (!isOpen) return;

    const close = () => setOpen(false);

    const handleClickOutside = event => {
      if (ref.current != null && !ref.current.contains(event.target)) {
        close();
      }
    };

    document.addEventListener('click', handleClickOutside);
    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  return [isOpen, setOpen];
}
